const React = require("react")
const { Search } = require("./icons/search")

module.exports = {
  Search: (props) => <Search {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/modernFloatLabel/index.js